import { call, put } from 'redux-saga/effects';
import {
  fetchProductGroupLabeling,
  setLoadingGroupsLabelingTableAction,
  updateBulkAllocationValueAction,
} from '../actions';
import ProductValueService from '@services/product-value-service/product-value-service';
import { enqueSnackAction } from '@app/store/snacks';
import { setBackdropLoadingAction } from '@app/store/app/actions';

export function* updateBulkAllocationValueSaga(
  action: ReturnType<typeof updateBulkAllocationValueAction>
) {
  try {
    yield put(setBackdropLoadingAction({ payload: true }));
    yield put(setLoadingGroupsLabelingTableAction({ payload: true }));
    yield call(ProductValueService.updateBulkAllocationValue, action.payload);
    yield put(
      fetchProductGroupLabeling({
        payload: {
          productGroupIds: action.payload.productGroupIds,
          valueAllocations: action.payload.valueAllocations,
        },
      })
    );
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Allocations Value is saved',
          options: {
            variant: 'success',
          },
          key: 'save bulk allocation level',
        },
      })
    );
  } catch (e) {
    if (e.response && e.response.status === 409) {
      yield put(
        enqueSnackAction({
          notification: {
            message: e.response.data.message,
            options: {
              variant: 'error',
            },
            key: 'create product value bulk error',
          },
        })
      );
    }
    yield put(
      enqueSnackAction({
        notification: {
          message: 'Something wrong...',
          options: {
            variant: 'error',
          },
          key: 'create product value bulk error',
        },
      })
    );
  } finally {
    yield put(setBackdropLoadingAction({ payload: false }));
    yield put(setLoadingGroupsLabelingTableAction({ payload: false }));
  }
}
